<template>
  <div class="rs-page-title">
    <RsAvatar
      :key="iconKey"
      square
      variant="info"
      soft
      :icon="icon"
    />
    <div>
      <h1>{{ title }}</h1>
      <slot />
    </div>
  </div>
</template>
<script lang="ts">

import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsPageTitle',

  props: {
    title: String,
    icon: String,
  },

  data() {
    return {
      iconKey: 0,
    };
  },

  watch: {
    icon() {
      this.iconKey += 1;
    },
  },
});
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
.rs-page-title {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  h1 {
    display: block;
    margin: 0;
    font-size: 24px;
  }
  p{
    margin: 0;
    font-size: 14px;
    color: $tertiary-muted;
  }
  .rs-avatar {
    margin-right: 1rem;
    width: 48px;
    height: 48px;
  }
}
</style>
